import { ModalProps } from 'antd'
import { BUTTON_TYPES, Button } from 'components/Button'

import { Popup } from 'components/Popup'
import { Typography } from 'components/Typography'
import { BTN_TXT } from 'constants/txt'

type TProps = Partial<ModalProps> & {
  onCancelPress: () => void
  onDeletePress: () => void
}

const ConfirmDeletionPopup = ({
  onCancelPress,
  onDeletePress,
  ...rest
}: TProps) => {
  return (
    <Popup
      width={442}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={onCancelPress} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={onDeletePress}
            danger
            upperCase
          >
            {BTN_TXT.DELETE}
          </Button>
        </>
      }
      {...rest}
    >
      <Typography.Body1>
        This file and all related versions will be deleted. Do you want to
        proceed?
      </Typography.Body1>
    </Popup>
  )
}

export default ConfirmDeletionPopup
